import script from "./DisplayCard.vue?vue&type=script&setup=true&lang=js"
export * from "./DisplayCard.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__